<template>
  <b-modal id="import-travellers" ref="import-travellers" v-model="showModal"
           :title="trans('title')" @ok="submit" :ok-disabled="okDisabled"
           :ok-title="$t('_send')" :cancel-title="$t('_cancel')"
  >
    <div class="description">
        <p>{{ trans("text") }}</p>

    </div>
    <div class="row traveller-action">
        <a id="travellers-download-btn" :href="downloadExampleUrl" >
            <div class="row" id="traveller-model">

              <div class="col-2">
                <span class="btn orange-white">
                  <i class="fas fa-file-download"></i>
                </span>
              </div>
              <div class="col-10">
                <span>
                  {{ trans("dlExample") }}
                </span>
              </div>
            </div>
        </a>
        <b-tooltip target="travellers-download-btn">{{ trans("dlExample") }}</b-tooltip>
      </div>
      <div class="traveller-action">

        <file-input :required="true" :types="fileExtensions"
                    v-model="val.get('file')" @input="setFile"
                    placeholder=" " id="tooltip-travellers-upload" class="bg-light"
        />
        <b-tooltip target="tooltip-travellers-upload" triggers="hover">
            {{ $t('_tooltip.upload' )}}
        </b-tooltip>
        <p class="file-type-format">{{ trans("allowedExtensions", { formats: fileExtensions }) }}</p>

      </div>



    </div>
    <!--<b-alert v-if="alert.show" :variant="alert.variant" class="col-12" show dismissible>
      <div v-if="alert.msg" v-html="alert.msg" />

      <div v-for="msg in alert.data">
        {{ msg }}
      </div>
    </b-alert>-->
  </b-modal>
</template>

<script>
import fileInput from '@/components/frontoffice/form/baseInput/file'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import CommonApi from '@/api/commonApi'
import fa from '@/components/global/icon/fontAwesome'
import FormSubmitter from '@/api/formSubmitter'

const api = new CommonApi()
const submitter = new FormSubmitter('travellers_import')

export default {
  components: {
    fileInput,
    submitButton,
    fa
  },

  data () {
    return {
      showModal: false,
      isLoading: false,
      alert: {},
      val: new FormData(),
      file: null
    }
  },

  created () {
    this.resetAlert()
  },

  methods: {
    resetAlert () {
      this.alert = {
        show: false,
        variant: 'success',
        data: [],
        nbImported: 0,
        nbEdited: 0,
        msg: null
      }
    },

    trans (key, params) {
      return this.$t(`traveller.import.${key}`, params || null)
    },

    setFile (file) {
      this.file = file
      this.val.set('file', file)
    },

    submit (event) {
      event.preventDefault()
      this.resetAlert()
      if (!this.val.get('file')) return
      this.isLoading = true
      submitter.submitRequest(this.val, this.$route.params.id)
        .then(r => {
          if (r.data.success) {
            this.dealSuccess(r.data.data.warnings, r.data.data.nbImported, r.data.data.nbEdited)
          } else { this.dealFailure(r.data.data.errors) }

          this.isLoading = false
          this.alert.show = true
        })
    },

    dealSuccess (warnings, nbImported, nbEdited) {
      this.alert.msg = this.$tc('traveller.import.alert.success', nbImported, { nb: nbImported }) + ' | ' + this.$tc('traveller.import.alert.edit', nbEdited, { nb: nbEdited })

      if (Object.keys(warnings).length) {
        this.alert.variant = 'warning'

        for (const key in warnings) {
          this.alert.data.push(`${key} : ${this.$t('error.' + warnings[key])}`)
        }

        this.alert.msg += `<br/>${this.$t('traveller.import.alert.warning')}`
      }

      this.$emit('travellerImported', this.alert)
    },

    dealFailure (errors) {
      this.alert.variant = 'danger'
      this.alert.data = errors.map(e => this.$t(`error.${e}`))
      this.$emit('travellerImported', this.alert)
    }
  },

  computed: {
    fileTypes () {
      return this.$store.getters['security/files']['travellerImport']['mime'].join()
    },

    fileExtensions () {
      return this.$store.getters['security/files']['travellerImport']['extension'].map(ext => `.${ext}`).join(', ')
    },

    downloadExampleUrl () {
      return api.downloadTravellerImportExample(this.$route.params.id)
    },

    okDisabled () {
      return this.isLoading || !(this.file instanceof File)
    }
  }
}
</script>
<style scoped lang="scss">
#travellers-download-btn{
  span:first-child{
    font-size: medium;
    margin-right: .5rem;
  }
}
.traveller-action{
  margin-left:inherit;
  margin-bottom:2%;
}
#tooltip-travellers-upload{
  width: 100%;
}
#traveller-model{
  align-items: center;
}
</style>
